import { Box, Typography } from '@mui/material';
import { keyframes } from '@mui/system';
import type { CameraStatus } from '../../api/flashbackApi/types.ts';

const dotPulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
`;

interface Props {
  status: CameraStatus;
}

export function StatusPill({ status }: Props): JSX.Element {
  const isActive = status === 'active';
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        borderRadius: 999,
        px: 1,
        py: 0.5,
        fontSize: 12,
        fontWeight: 500,
        backgroundColor: isActive ? 'rgba(46, 125, 50, 0.12)' : 'rgba(107, 114, 128, 0.12)',
        color: isActive ? 'var(--app-success)' : 'var(--app-text-secondary)',
      }}
    >
      <Box
        component="span"
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          backgroundColor: isActive ? 'var(--app-success)' : 'var(--app-text-secondary)',
          ...(isActive ? { animation: `${dotPulse} 1.4s ease-in-out infinite` } : {}),
        }}
      />
      <Typography component="span" variant="caption" sx={{ fontSize: 12, fontWeight: 500, lineHeight: 1 }}>
        {isActive ? 'Online' : 'Offline'}
      </Typography>
    </Box>
  );
}
